// extracted by mini-css-extract-plugin
export default {"detailsBody":"style_detailsBody__hpvmx","host":"style_host__MO8fs","tablesPanel":"style_tablesPanel__y+jNJ"};